import BaseComponent from '../abstracts/BaseComponent';

export default class ScrollDirectionComponent extends BaseComponent {
  get CLASSES() {
    return {
      up: 'scroll-up',
      down: 'scroll-down',
      active: 'active'
    };
  }

  get SELECTORS() {
    return {
      trigger: '.js-activate-on-scroll',
    };
  }

  constructor(element) {
    super(element);
    // console.log('ScrollDirectionComponent', 'this.$el', this.$el, 'this.$options.upIfZero', this.$options.upIfZero);

    this.observeScroll();
  }

  observeScroll() {
    window.addEventListener('wheel', (e) => {

      const targetToActivate = document.querySelectorAll(this.SELECTORS.trigger);
      
      if (targetToActivate) {
        targetToActivate.forEach(target => {
          if(window.scrollY >= 30) {
            target.classList.add(this.CLASSES.active);
          } else {
            target.classList.remove(this.CLASSES.active);
          }
        });

      }

      // PITTI20-90 PITTI20-913 PITTI20-1424
      if (e.target.closest('.listing-grid-sidebar-right') || e.target.closest('.carousel-nav--vertical') || e.target.closest('.dropdown')) {
        return;
      }

      const scrollDir = e.deltaY > 0 ? 'down' : 'up';

      switch (scrollDir) {
        case 'up':
          this.$el.classList.remove(this.CLASSES.down);
          this.$el.classList.add(this.CLASSES.up);
          break;
        case 'down':
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.add(this.CLASSES.down);
          break;
        default:
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.remove(this.CLASSES.down);
      }
    });

    // PITTI20-1298
    this.$options.upIfZero && document.addEventListener('scroll', () => {
      // console.log('ScrollDirectionComponent', 'window.scrollY', window.scrollY);

      if (window.scrollY === 0) {
        this.$el.classList.remove(this.CLASSES.down);
        this.$el.classList.add(this.CLASSES.up);
      }
    });
  }
}
